import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { RouteService } from "../core/services";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router, private routeService: RouteService) { }

    // Return false if the user is not logged in
    canActivate(route: ActivatedRouteSnapshot) {
        const isAuthenticated = localStorage.getItem('id_token');
        if (isAuthenticated) {
            return true;
        } else {
            const currentUrl = this.routeService.getResolvedUrl(route);
            const queryParams = { redirect: currentUrl };
            this.router.navigate(['/login'], { queryParams });
            this.auth.logout();
            return false;
        }
    }
}
